// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
// lenis smooth scroll initialisering

// TEMPORARILY DISABLED FOR DEBUGGING
// Lenis sets pointer-events: none on all iframes, breaking Zakeke/Melco configurators
// To re-enable, set this to false
const LENIS_DISABLED = true;

class LenisScroll {
  constructor() {
    this.lenis = null;
    if (!LENIS_DISABLED) {
      this.init();
    } else {
      console.log('Lenis smooth scroll is DISABLED for debugging');
    }
  }

  init() {
    // ladda lenis från cdn
    if (typeof Lenis === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/@studio-freight/lenis@1.0.42/dist/lenis.min.js';
      script.onload = () => this.initLenis();
      document.head.appendChild(script);
    } else {
      this.initLenis();
    }
  }

  initLenis() {
    // Wait for GSAP to be available
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(() => this.initLenis(), 50);
      return;
    }

    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // lägg till lenis-klass på html
    document.documentElement.classList.add('lenis');

    // Synchronize Lenis scrolling with GSAP's ScrollTrigger
    this.lenis.on('scroll', ScrollTrigger.update);

    // Add Lenis's raf method to GSAP's ticker
    // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    gsap.ticker.add((time) => {
      this.lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    gsap.ticker.lagSmoothing(0);

    // stoppa scroll vid modaler/drawers
    document.addEventListener('modal:open', () => this.lenis.stop());
    document.addEventListener('modal:close', () => this.lenis.start());
    document.addEventListener('drawer:open', () => this.lenis.stop());
    document.addEventListener('drawer:close', () => this.lenis.start());
    
    // Make lenis globally available
    window.lenis = this.lenis;
  }

  destroy() {
    if (this.lenis) {
      this.lenis.destroy();
      document.documentElement.classList.remove('lenis');
    }
  }
}

// initialisera när dom är redo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.lenisScroll = new LenisScroll();
  });
} else {
  window.lenisScroll = new LenisScroll();
}
